import apiClient from './client';
import type { ApiKey, CreateApiKeyResponse, ListApiKeysResponse } from '../types';

export async function listApiKeys(): Promise<ApiKey[]> {
  const response = await apiClient.get<ListApiKeysResponse>('/user/api-keys');
  return response.data.keys;
}

export async function createApiKey(name?: string): Promise<CreateApiKeyResponse> {
  const response = await apiClient.post<CreateApiKeyResponse>('/user/api-keys', {
    name,
  });
  return response.data;
}

export async function revokeApiKey(id: string): Promise<void> {
  await apiClient.delete(`/user/api-keys/${id}`);
}

export async function deleteApiKey(id: string): Promise<void> {
  await apiClient.delete(`/user/api-keys/${id}/permanent`);
}
